import React, { useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './About.css';
import Typewriter from 'typewriter-effect';
import { InView } from 'react-intersection-observer';

const About = () => {

  const words = [' Web Developer', ' Learner', ' Freelancer', ' Problem Solver'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentWord, setCurrentWord] = useState(words[currentIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCurrentWord(words[currentIndex]);
  }, [currentIndex]);

  const [showHeading, setShowHeading] = React.useState(false);
  const [showDescription, setShowDescription] = React.useState(false);

  const headingProps = useSpring({
    opacity: showHeading ? 1 : 0,
    transform: showHeading ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 1000 },
    delay: 300,
  });

  const descriptionProps = useSpring({
    opacity: showDescription ? 1 : 0,
    transform: showDescription ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 1000 },
    delay: 100,
  });

  useEffect(() => {
    setShowHeading(true);
    setTimeout(() => {
      setShowDescription(true);
    }, 700);
  }, []);

  return (
    <div className="about">
      <animated.span style={{ ...headingProps, color: 'white', fontSize: '25px', fontFamily: 'Exo' }}>
        Hi, my name is
      </animated.span>
      <br />
      <animated.h2 className="about-heading" style={headingProps}>
        Rohit Kumar Sahu
      </animated.h2>
      <div className="lne-brk">
        <animated.h1 className="about-heading-sec" style={headingProps}>
          I am a
          <Typewriter
            options={{
              strings: words,
              autoStart: true,
              loop: true,
            }}
            className="type"
          />
        </animated.h1>
      </div>
      <animated.p className="about-description" style={descriptionProps}>
        I'm passionate about crafting digital solutions. As a dedicated web developer, I thrive on creating impactful
        and user-centric online experiences. I'm deeply engaged in the process of building innovative and accessible
        solutions. Currently, I'm honing my skills and contributing to the world of technology.
      </animated.p>
      <animated.button style={descriptionProps} class="button-57" role="button"><a href="https://drive.google.com/file/d/11LhYoFoU0_Vd_qSCQj5YqgWe_gaGp_ot/view?usp=sharing" style={{ textDecoration: 'none', color: 'white' }} target='_blank'><span class="text">Resume</span><span>View Resume</span></a></animated.button>
    </div>
  );
};

export default About;
